/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListUserSessionClientsResult,
  ListUserSessionClientsResult$inboundSchema,
} from "../components/listusersessionclientsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListUserSessionClientsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListUserSessionClientsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListUserSessionClientsSecurity = {
  option1?: ListUserSessionClientsSecurityOption1 | undefined;
  option2?: ListUserSessionClientsSecurityOption2 | undefined;
};

export type ListUserSessionClientsRequest = {
  /**
   * Filter to clients registered with this issuer.
   */
  userSessionIssuerId?: string | undefined;
  /**
   * Pagination cursor: id of the last item from the previous page.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListUserSessionClientsResponse = {
  result: ListUserSessionClientsResult;
};

/** @internal */
export type ListUserSessionClientsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListUserSessionClientsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListUserSessionClientsSecurityOption1$Outbound,
    ListUserSessionClientsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listUserSessionClientsSecurityOption1ToJSON(
  listUserSessionClientsSecurityOption1: ListUserSessionClientsSecurityOption1,
): string {
  return JSON.stringify(
    ListUserSessionClientsSecurityOption1$outboundSchema.parse(
      listUserSessionClientsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListUserSessionClientsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListUserSessionClientsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListUserSessionClientsSecurityOption2$Outbound,
    ListUserSessionClientsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listUserSessionClientsSecurityOption2ToJSON(
  listUserSessionClientsSecurityOption2: ListUserSessionClientsSecurityOption2,
): string {
  return JSON.stringify(
    ListUserSessionClientsSecurityOption2$outboundSchema.parse(
      listUserSessionClientsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListUserSessionClientsSecurity$Outbound = {
  Option1?: ListUserSessionClientsSecurityOption1$Outbound | undefined;
  Option2?: ListUserSessionClientsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListUserSessionClientsSecurity$outboundSchema: z.ZodMiniType<
  ListUserSessionClientsSecurity$Outbound,
  ListUserSessionClientsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListUserSessionClientsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListUserSessionClientsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listUserSessionClientsSecurityToJSON(
  listUserSessionClientsSecurity: ListUserSessionClientsSecurity,
): string {
  return JSON.stringify(
    ListUserSessionClientsSecurity$outboundSchema.parse(
      listUserSessionClientsSecurity,
    ),
  );
}

/** @internal */
export type ListUserSessionClientsRequest$Outbound = {
  user_session_issuer_id?: string | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListUserSessionClientsRequest$outboundSchema: z.ZodMiniType<
  ListUserSessionClientsRequest$Outbound,
  ListUserSessionClientsRequest
> = z.pipe(
  z.object({
    userSessionIssuerId: z.optional(z.string()),
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userSessionIssuerId: "user_session_issuer_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listUserSessionClientsRequestToJSON(
  listUserSessionClientsRequest: ListUserSessionClientsRequest,
): string {
  return JSON.stringify(
    ListUserSessionClientsRequest$outboundSchema.parse(
      listUserSessionClientsRequest,
    ),
  );
}

/** @internal */
export const ListUserSessionClientsResponse$inboundSchema: z.ZodMiniType<
  ListUserSessionClientsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListUserSessionClientsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listUserSessionClientsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListUserSessionClientsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUserSessionClientsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserSessionClientsResponse' from JSON`,
  );
}
